import { cookies } from '@/plugins/cookies';

export const PENDING_ONBOARDING_KEY = 'pendingOnboarding';

const normalise = (email?: string | null): string => email?.trim().toLowerCase() ?? '';

// Context: registration writes the marker same-origin here and as a cookie in the auth SPA
// (the cross-origin hand-off), so a reader has to check both carriers (TCH-469).
export const pendingOnboardingEmail = (): string =>
  normalise(localStorage.getItem(PENDING_ONBOARDING_KEY) ?? cookies.get(PENDING_ONBOARDING_KEY));

// Context: the marker is bound to the address that registered, so a different user signing in
// on the same browser is neither pulled into someone else's onboarding nor able to clear it.
export const ownsPendingOnboarding = (email?: string | null): boolean => {
  const pending = pendingOnboardingEmail();
  return pending !== '' && pending === normalise(email);
};
